import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "modal-container-element"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "filter-block" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "cards-container" }
const _hoisted_6 = ["card-title", "description", "icon-src", "icon-name", "onClick"]
const _hoisted_7 = {
  slot: "title",
  class: "card-title"
}
const _hoisted_8 = ["actions"]

import { useStore } from 'vuex'
import { ref, computed, onMounted, onUnmounted } from 'vue'
import Masthead from '@shell/components/ResourceList/Masthead';

import { EPINIO_TYPES } from '../types'

import Loading from '@shell/components/Loading.vue'
import { startPolling, stopPolling } from '../utils/polling';

import CatalogServiceModal from '../components/service/CatalogServiceModal.vue';
import CatalogServiceDeleteModal from '../components/service/CatalogServiceDeleteModal.vue';
import EpinioCatalogServiceModel from '../models/catalogservices';
import { overrideTableRows } from '../utils/table-formatters';


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogservices',
  props: {
    schema: {}
  },
  setup(__props: any) {

const store = useStore()
const props = __props; // eslint-disable-line @typescript-eslint/no-unused-vars

const pending = ref(true);
const searchQuery = ref(null);

const catalogServiceModal = ref<InstanceType<typeof CatalogServiceModal> | null>(null);
const deleteModal = ref<InstanceType<typeof CatalogServiceDeleteModal> | null>(null);

const resource: string = EPINIO_TYPES.CATALOG_SERVICE;

const canEdit = computed(() => {
  const can = store.getters['epinio/can'];

  return can && (can('catalog_service_write') || can('catalog_service'));
});
const canDelete = canEdit;
const canCreate = canEdit;

onMounted(async () => {
  store.dispatch('epinio/me');
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.CATALOG_SERVICE });
  pending.value = false;

  startPolling(["namespaces", "applications", "catalogservices", "services"], store);
});

onUnmounted(() => {
  stopPolling(["namespaces", "applications", "catalogservices", "services"]);
});

const list = computed(() => {
  const catalogList = store.getters['epinio/all'](EPINIO_TYPES.CATALOG_SERVICE)

  // filter empty catalog services that are added during delete
  const filteredList = catalogList.filter((service: EpinioCatalogServiceModel) => service.meta.name !== '')

  const rowActions = (row: EpinioCatalogServiceModel) => {
    const out: any[] = [];

    if (canEdit.value) {
      out.push({
        label: 'Edit',
        enabled: true,
        action: () => catalogServiceModal.value?.openEdit(row),

      });
    }
    if (canDelete.value) {
      out.push({
        enabled: true,
        label: 'Delete',
        action: () => deleteModal.value?.openDelete(row),
      });
    }

    return out;
  };

  const overrideProps = [
    {
      prop: 'availableActions',
      value: rowActions,
      conditionFn: () => true,
    },
  ];

  const processedList = overrideTableRows(filteredList, overrideProps);

  if (!searchQuery.value) {
    return processedList;
  } else {
    const query = searchQuery.value.toLowerCase();

    return processedList.filter((e) => e?.chart.toLowerCase().includes(query) ||
      e?.description.toLowerCase().includes(query) ||
      e?.short_description.toLowerCase().includes(query));
  }
})

const showDetails = (chart: any) => {
  store.$router.push(chart.detailLocation)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (pending.value)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Masthead), {
            schema: _ctx.schema,
            resource: _unref(resource)
          }, {
            createButton: _withCtx(() => [
              (_unref(canCreate))
                ? (_openBlock(), _createElementBlock("trailhand-button", {
                    key: 0,
                    variant: "primary",
                    size: "large",
                    onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (catalogServiceModal.value?.openCreate()))
                  }, _toDisplayString(_ctx.t('generic.create')), 33))
                : (_openBlock(), _createElementBlock("div", _hoisted_2))
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(canCreate)) + " ", 1)
            ]),
            _: 1
          }, 8, ["schema", "resource"]),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("trailhand-text-input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
              type: "search",
              class: "input-sm",
              placeholder: _ctx.t('catalog.charts.search')
            }, null, 8, _hoisted_4), [
              [_vModelText, searchQuery.value]
            ])
          ]),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (service) => {
              return (_openBlock(), _createElementBlock("trailhand-card", {
                key: service.id,
                "card-title": service.meta.name,
                description: service.short_description,
                "icon-src": service.service_icon ? service.service_icon : null,
                "icon-name": service.service_icon ? null : 'database',
                clickable: "",
                onClick: ($event: any) => (showDetails(service))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h3", null, _toDisplayString(service.meta.name), 1),
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  (service.availableActions.length > 0)
                    ? (_openBlock(), _createElementBlock("trailhand-action-menu", {
                        key: 0,
                        actions: service.availableActions
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_6))
            }), 128))
          ])
        ])),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createVNode(CatalogServiceModal, {
      ref_key: "catalogServiceModal",
      ref: catalogServiceModal
    }, null, 512),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createVNode(CatalogServiceDeleteModal, {
      ref_key: "deleteModal",
      ref: deleteModal
    }, null, 512)
  ], 64))
}
}

})